import { css } from "@emotion/react"

const ArticleFigure = ({ children }) => (
  <figure
    css={css`
      margin: 1rem 0;
    `}
  >
    {children}
  </figure>
)

export default ArticleFigure
